"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTagCloseButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TagCloseButtonMixin = require("../../mixins/components/TagCloseButtonMixin");
var StyledTagCloseButton = /*#__PURE__*/_styledComponents.default.button.withConfig({
  displayName: "StyledTagCloseButton",
  componentId: "c11n-8-107-0__sc-1lm2q1d-0"
})(["", ""], _TagCloseButtonMixin.TagCloseButtonMixin);
exports.StyledTagCloseButton = StyledTagCloseButton;